import { useState, useMemo } from "react";
import { faqData, faqOptions } from "../data/faq-data";
import { FaqItem, FaqOption } from "../types";

export function useFaq() {
  const [selectedOps, setSelectedOps] = useState<string>("");

  const options = useMemo<FaqOption[]>(() => faqOptions, []);

  const currentFaqItems = useMemo<FaqItem[]>(() => {
    if (!selectedOps || !faqData[selectedOps]) {
      return [];
    }
    return faqData[selectedOps];
  }, [selectedOps]);

  const handleSelectOps = (value: string) => {
    setSelectedOps(value);
  };

  return {
    selectedOps,
    options,
    currentFaqItems,
    handleSelectOps,
  };
}
